import React from "react";
import { WorkPatternImportWarning } from "../../hooks/WorkPatternImport/useWorkPatternImportCsvParser";
import { Button } from "@datapay-by-datacom/design-system";
import styles from "./WorkPatternImportWarnings.module.css";

interface WorkPatternImportWarningsProps {
  warnings: WorkPatternImportWarning[];
  /** R14 Cancel — abandon the load and return to upload. */
  onCancelImport?: () => void;
}

/**
 * Summary banner for StandardHours/StandardDays mismatch warnings emitted by
 * the CSV parser. These are non-blocking — the import will proceed — but the
 * user should review the values before confirming.
 */
export function WorkPatternImportWarnings({
  warnings,
  onCancelImport,
}: WorkPatternImportWarningsProps) {
  if (warnings.length === 0) {
    return null;
  }

  return (
    <div className={styles.warningContainer} aria-live="polite">
      <h4>Warnings — import will proceed, but please review:</h4>
      <ul>
        {warnings.map((warning, index) => (
          <li key={index} className={styles.warning}>
            <strong>Row {warning.rowNumber} ({warning.workPatternName}):</strong>{" "}
            {warning.message}
          </li>
        ))}
      </ul>
      {onCancelImport && (
        <div className={styles.cancelRow}>
          <Button variant="tertiary" onPress={onCancelImport}>
            Cancel import
          </Button>
        </div>
      )}
    </div>
  );
}
